import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="fixed top-4 sm:top-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none"
    >
      <nav
        className={`pointer-events-auto transition-all duration-300 flex items-center justify-between w-full max-w-5xl rounded-full px-5 py-3 sm:px-6 sm:py-3.5 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-md shadow-lg border border-jeruel-gray/50'
            : 'bg-white shadow-md border border-transparent'
        }`}
      >
        <div className="flex items-center">
          <img
            src="https://media-manager-c.questera.ai/greta-media/e842e0d41a21d55020287eff0799ef371d19c38aa92b057bb3ca6b830a67458ee61195b657411aeb9534fd09dfbbea8f/images/aW1hZ2UvcG5n/229e7e8b309100a067ae3bf39e6e27d1.png"
            alt="Jeruel Global Logo"
            className="h-7 sm:h-9 w-auto object-contain"
          />
        </div>

        <a
          href="#download-form"
          className="inline-flex items-center justify-center px-5 py-2.5 sm:px-7 sm:py-3 text-sm font-bold rounded-full text-white bg-jeruel-primary hover:bg-jeruel-light transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-px"
        >
          Get the Report
        </a>
      </nav>
    </motion.div>
  );
};

export default Navbar;